import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="text-lg font-heading text-background-50 mb-4">
              妈妈的朋友
            </h3>
            <p className="text-sm text-background-400 leading-relaxed">
              致力于为影视爱好者提供高质量的影视资讯、深度影评和观影指南。发现好电影，从这里开始。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/category/dianying-tuijian"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  电影推荐
                </Link>
              </li>
              <li>
                <Link
                  to="/category/yingping-jiexi"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  影评解析
                </Link>
              </li>
              <li>
                <Link
                  to="/category/juji-zhuizong"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  剧集追踪
                </Link>
              </li>
              <li>
                <Link
                  to="/category/jingdian-huigu"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  经典回顾
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <a
                  href="/about"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  用户口碑
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">
              热门标签
            </h4>
            <div className="flex flex-wrap gap-2">
              {['在线观看', '高清', '电影推荐', '影评', '韩国电影', '剧情片'].map(
                (tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 text-xs rounded-full bg-background-800 text-background-300 whitespace-nowrap"
                  >
                    {tag}
                  </span>
                )
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 妈妈的朋友. 保留所有权利.
          </p>
          <p className="text-xs text-background-500">
            本站内容仅供影视爱好者交流参考
          </p>
        </div>
      </div>
    </footer>
  );
}